module.exports = __webpack_public_path__ + "static/img/aboutme_qrcode.65e0663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutme_qrcode.png
// module id = 6phz
// module chunks = 27